"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRecordClient = createRecordClient;
const util_typescript_1 = require("@varos/util-typescript");
function createRecordClient(config) {
    /**
     * Process properties to create snippets for snippet-type properties
     * and replace string content with snippet IDs
     */
    async function processSnippetProperties(collection, properties) {
        const snippetProperties = collection.properties.filter((property) => property.type === 'snippet');
        if (snippetProperties.length === 0) {
            return properties;
        }
        console.debug(`found ${snippetProperties.length} snippet properties`);
        const processedProperties = { ...properties };
        for (const property of snippetProperties) {
            const snippetContent = properties[property.key] ?? null;
            (0, util_typescript_1.assert)(snippetContent === null || typeof snippetContent === 'string', `invalid content for property ${property.key}`);
            console.debug(`processing snippet property ${property.key} with content ${snippetContent}`);
            const snippet = await config.client.user.snippet.create({
                content: snippetContent,
            });
            console.debug(`snippet created ${snippet.id}`);
            processedProperties[property.key] = snippet.id;
        }
        return processedProperties;
    }
    /**
     * Transform snippet properties from IDs back to raw content values
     */
    async function transformSnippetProperties(collection, properties) {
        const snippetProperties = collection.properties.filter((property) => property.type === 'snippet');
        if (snippetProperties.length === 0) {
            return properties;
        }
        console.debug(`transforming ${snippetProperties.length} snippet properties`);
        const transformedProperties = { ...properties };
        for (const property of snippetProperties) {
            const snippetId = properties[property.key];
            if (snippetId === null || snippetId === undefined) {
                transformedProperties[property.key] = null;
                continue;
            }
            (0, util_typescript_1.assert)(typeof snippetId === 'string', `invalid snippet ID for property ${property.key}`);
            console.debug(`fetching snippet ${snippetId} for property ${property.key}`);
            const snippet = await config.client.user.snippet.retrieve(snippetId);
            console.debug(`snippet retrieved ${snippet.id}`);
            transformedProperties[property.key] = snippet.content;
        }
        return transformedProperties;
    }
    return {
        async retrieve(collection, id) {
            const record = await config.client.user.content.retrieve(id);
            // Transform snippet properties from IDs back to raw content values
            const transformedProperties = await transformSnippetProperties(collection, record.properties || {});
            return {
                ...record,
                properties: transformedProperties,
            };
        },
        async create(collection, payload) {
            // Process snippet properties before creating the record
            const processedProperties = await processSnippetProperties(collection, payload.properties || {});
            const record = await config.client.user.content.create({
                ...payload,
                collection: collection.id,
                properties: processedProperties,
            });
            // Transform snippet properties back to content for the returned record
            const transformedProperties = await transformSnippetProperties(collection, record.properties || {});
            return {
                ...record,
                properties: transformedProperties,
            };
        },
        async update(collection, record, props) {
            // Process snippet properties before updating the record
            const processedProperties = props.properties
                ? await processSnippetProperties(collection, props.properties)
                : undefined;
            const updated = await config.client.user.content.update(record.id, {
                ...props,
                ...(processedProperties && { properties: processedProperties }),
            });
            // Transform snippet properties back to content for the returned record
            const transformedProperties = await transformSnippetProperties(collection, updated.properties || {});
            return {
                ...updated,
                properties: transformedProperties,
            };
        },
        async delete(collection, record) {
            await config.client.user.content.archive(record.id);
        },
    };
}
//# sourceMappingURL=recordProvider.js.map